import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../lib/firebase.js";
import { COL } from "../data/collections.js";

const AuthContext = createContext({ user: null, profile: null, loading: true });

export function AuthProvider({ children }) {
  const [state, setState] = useState({ user: null, profile: null, loading: true });

  useEffect(() => {
    return onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({ user: null, profile: null, loading: false });
        return;
      }
      // Profile in `users/{uid}` is the admin allowlist; absence = not authorised.
      let profile = null;
      try {
        const snap = await getDoc(doc(db, COL.users, user.uid));
        if (snap.exists()) profile = { id: snap.id, ...snap.data() };
      } catch (err) {
        console.error("[auth] profile fetch failed", err);
      }
      setState({ user, profile, loading: false });
    });
  }, []);

  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
